import styled from "styled-components";

export const OptionContainer = styled.li`
  button {
    padding: 10px 1rem;
    border: none;
    background-color: inherit;

    transition: 0.3s all;

    border-radius: 0 !important;

    max-height: 58px;

    width: 100%;
    text-align: start;

    :hover:not(:disabled) {
      cursor: pointer;
      background-color: ${({ theme }) =>
        theme.console.sidebar.optionHoverBackgroundColor};
    }

    :disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }

    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    word-break: break-word;

    color: ${({ theme }) => theme.console.inputColor};
  }

  &.active button {
    cursor: default !important;
    background-color: ${({ theme }) =>
      theme.console.sidebar.optionHoverBackgroundColor};
  }
`;
